export default class TechIndicatorTabDO {
    constructor(tabType, displayText, isMovable = false) {
            this.TabType = tabType;
            this.IsMovable = isMovable;
            this.DisplayText = displayText;
    }
}